import React, { useContext } from 'react';
import { ThemeContext } from "../../context/ThemeContext";

const Footer = ({ className = '' }) => {
    const { theme, themes } = useContext(ThemeContext);
    return (
        <footer className={`p-4 pt-0 mt-0 ${className}`.trim()}>
            <div className={`${themes[theme].text} container mx-auto text-center text-xs sm:text-base`}>
                © {new Date().getFullYear()} Shivam Patel. All rights reserved.
            </div>
        </footer>
    );
};

export default Footer;
